import '.ag{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.hj{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a3{justify-content:center;}.ssr-plugin'
import '.b7{align-items:flex-start;}.ssr-plugin'
import '.dd{padding:2rem;}.ssr-plugin'
import '.e3{background:var(--palette-white);}.ssr-plugin'
import '.ax{overflow:hidden;}.ssr-plugin'
import '.br{position:absolute;}.ssr-plugin'
import '.jl{top:50%;}.ssr-plugin'
import '.jm{right:1rem;}.ssr-plugin'
import '.jn{transform:translateY(-50%);}.ssr-plugin'
import '.jo{width:120px;}.ssr-plugin'
import '.jp{height:120px;}.ssr-plugin'
import '.jq{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.gx{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.jr{max-width:calc(100% - 140px);}.ssr-plugin'
import '.js{font-size:4rem;}.ssr-plugin'
import '.ch{font-weight:700;}.ssr-plugin'
import '.jt{line-height:100%;}.ssr-plugin'
import '.h4{margin:0px;}.ssr-plugin'
import '.a6{color:var(--brand-secondary);}.ssr-plugin'
import '.a7{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ag n hj d e a3 b7 dd e3 ax"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="br jl jm jn jo jp jq d r a3"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ag gx d e b7 s jr"
      >
        <div className="js ch jt h4 a6 a7"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
